import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { handleError, isAdmin } from "src/Common/function";
import BranchBar from "src/Components/branchbar/BranchBar";
import ReportService from "src/Services/API/report.service";
import UserService from "src/Services/API/user.service";
import HoursWorked from "./hoursworked";
import OpenWorkOrders from "./openworkorders";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import CompletedWorkOrders from "./completedworkorders";

const AdHoc = () => {
  const [searchParams] = useSearchParams();
  const branch = Number(searchParams.get("branch"));
  const [userArray, setUserArray] = useState([]);
  const [openWORecipientIdList, setOpenWORecipientIdList] = useState([]);
  const [hoursWorkedRecipientIdList, setHoursWorkedRecipientIdList] = useState([]);
  const [completedWORecipientIdList, setCompletedWORecipientIdList] = useState([]);
  const [isOpenWoSending, setIsOpenWoSending] = useState(false);
  const [isHoursWorkedSending, setIsHoursWorkedSending] = useState(false);
  const [isCompletedWoSending, setIsCompletedWoSending] = useState(false);

  useEffect(() => {
    setOpenWORecipientIdList([]);
    setHoursWorkedRecipientIdList([]);
    UserService.getAllUsers(branch)
      .then((response) => {
        if (response.status == 200) {
          setUserArray(response.data.filter((user) => user.isEnabled === true));
        }
      })
      .catch((error) => {
        handleError(error);
      });
  }, [branch]);

  const sendOpenWOReport = (past7Days, past30Days, customDays, startDate, endDate) => {
    if (openWORecipientIdList.length === 0) {
      toast("Please select at least one recipient");
      return;
    }
    if (!past7Days && !past30Days && !customDays) {
      return;
    }
    setIsOpenWoSending(true);
    ReportService.sendWOReport(
      branch,
      openWORecipientIdList,
      past7Days,
      past30Days,
      customDays,
      startDate,
      endDate,
      new Date(),
      "OPEN_WO"
    )
      .then((response) => {
        toast("Your report has been sent successfully");
      })
      .catch((error) => {
        handleError(error);
      })
      .finally(() => {
        setIsOpenWoSending(false);
      });
  };

  const sendHoursWorkedReport = (past7Days, past30Days, customDays, startDate, endDate) => {
    if (hoursWorkedRecipientIdList.length === 0) {
      toast("Please select at least one recipient");
      return;
    }
    if (!past7Days && !past30Days && !customDays) {
      return;
    }
    setIsHoursWorkedSending(true);
    ReportService.sendHoursWorkedReport(
      branch,
      hoursWorkedRecipientIdList,
      past7Days,
      past30Days,
      customDays,
      startDate,
      endDate,
      new Date()
    )
      .then((response) => {
        toast("Your report has been sent successfully");
      })
      .catch((error) => {
        handleError(error);
      })
      .finally(() => {
        setIsHoursWorkedSending(false);
      });
  };

  const sendCompletedWOReport = (past7Days, past30Days, customDays, startDate, endDate) => {
    if (completedWORecipientIdList.length === 0) {
      toast("Please select at least one recipient");
      return;
    }
    if (!past7Days && !past30Days && !customDays) {
      return;
    }
    setIsCompletedWoSending(true);
    ReportService.sendWOReport(
      branch,
      completedWORecipientIdList,
      past7Days,
      past30Days,
      customDays,
      startDate,
      endDate,
      new Date(),
      "COMPLETED_WO"
    )
      .then((response) => {
        toast("Your report has been sent successfully");
      })
      .catch((error) => {
        handleError(error);
      })
      .finally(() => {
        setIsCompletedWoSending(false);
      });
  };
  return (
    <div className="w-full">
      <OpenWorkOrders
        userArray={userArray}
        recipientIdList={openWORecipientIdList}
        setRecipientIdList={setOpenWORecipientIdList}
        sendReport={sendOpenWOReport}
        isSending={isOpenWoSending}
      />
      <div className="h-3" />
      <HoursWorked
        userArray={userArray}
        recipientIdList={hoursWorkedRecipientIdList}
        setRecipientIdList={setHoursWorkedRecipientIdList}
        sendReport={sendHoursWorkedReport}
        isSending={isHoursWorkedSending}
      />
      <div className="h-3" />
      <div className="hidden md:block">
        <CompletedWorkOrders
          userArray={userArray}
          recipientIdList={completedWORecipientIdList}
          setRecipientIdList={setCompletedWORecipientIdList}
          sendReport={sendCompletedWOReport}
          isSending={isCompletedWoSending}
        />
      </div>
    </div>
  );
};

export default AdHoc;
